import ICatalogItem from "src/models/Catalog";
import IOffer from "src/models/Offer";
import IPrice from "src/models/Price";

export default class OfferService {
  public bundleOffer(offer: IOffer, catalogData: ICatalogItem[], priceData: IPrice) {
    // Product price
    if (priceData.recurring && priceData.recurring.products && priceData.recurring.products.length) {
      const foundProduct = priceData.recurring.products.find((p: any) => p.sku === offer.selection.product.sku);
      if (foundProduct) {
        offer.selection.product.price = foundProduct.price;
      }
    }
    // Price totals
    offer.prices = {
      bankingTotal: 0,
      electronicTotal: 0,
      extras: 0,
      packageSalesPurchases: 0,
      totalPrice: 0,
      usageFees: 0,
    };
    if (priceData.usage && priceData.usage.products && priceData.usage.products.length) {
      priceData.usage.products.forEach((p: any) => {
        const foundExtra = offer.selection.extraServices.find((s: any) => s.sku === p.sku);
        if (foundExtra) {
          if (offer.prices) {
            if (p.sku === "NV-mkl" || p.sku === "NV-pal") {
              offer.prices.extras += p.price;
            } else if (p.sku === "NV-tr-ml" || p.sku === "NV-tr-ol") {
              offer.prices.packageSalesPurchases += p.price;
            } else if (p.sku !== "NV-net") {
              offer.prices.usageFees += p.price;
            }
          }
          foundExtra.price = p.price;
        }
        const foundFromPurchases = offer.selection.purchases.find((s: any) => s.sku === p.sku);
        if (foundFromPurchases) {
          if (offer.prices) {
            offer.prices.usageFees += p.price;
          }
          foundFromPurchases.price = p.price;
        }
        const foundFromSales = offer.selection.sales.find((s: any) => s.sku === p.sku);
        if (foundFromSales) {
          if (offer.prices) {
            offer.prices.usageFees += p.price;
          }
          foundFromSales.price = p.price;
        }
      });
    }
    // Some extra services (NV-kons, NV-cont) are not in usage but in recurring instead :)
    if (priceData.recurring && priceData.recurring.products && priceData.recurring.products.length) {
      priceData.recurring.products.forEach((p: any) => {
        const foundExtra = offer.selection.extraServices.find((s: any) => s.sku === p.sku);
        if (foundExtra) {
          if (offer.prices) {
            offer.prices.extras += p.price;
          }
          foundExtra.price = p.price;
        }
      });
    }

    // Training price and opening price
    if (priceData.oneTime && priceData.oneTime.products && priceData.oneTime.products.length) {
      (offer.selection.trainings || []).forEach((training: any) => {
        const foundTraining = (priceData.oneTime.products || []).find((p: any) => p.sku === training.sku);
        if (foundTraining) {
          training.price = foundTraining.price;
        }
      });

      // Sort trainings by price
      (offer.selection.trainings || []).sort((a, b) => ((a.price || 0) > (b.price || 0) ? 1 : -1));

      // Get opening fee price
      priceData.oneTime.products.find((p: any) => {
        const foundOpeningFee = offer.selection.extraServices.find((s) => s.sku === p.sku);
        if (foundOpeningFee) {
          foundOpeningFee.price = p.price;
          return true;
        }
        return false;
      });
    }

    // Total price including package price, sales and purchase in the package and extras
    offer.prices.totalPrice = (offer.selection.product.price || 0) + (offer.prices ? offer.prices.packageSalesPurchases || 0 : 0) + (offer.prices ? offer.prices.extras || 0 : 0);

    // Get the banking and electronic actions prices
    offer.bankingActions = Array<any>();
    offer.electronicActions = Array<any>();
    if (priceData.usage && priceData.usage.products) {
      priceData.usage.products.forEach((p: any) => {
        if (p.sku === "NV-vll" || p.sku === "NV-vlv" || p.sku === "NV-verk-p" || p.sku === "NV-tri") {
          (offer.electronicActions || []).push({ sku: p.sku, price: p.price });
        } else if (p.sku === "NV-vii" || p.sku === "NV-mak" || p.sku === "NV-til" || p.sku === "NV-toi") {
          (offer.bankingActions || []).push({ sku: p.sku, price: p.price });
        }
      });
    }
    offer.electronicActions.forEach((action: any) => {
      if (offer.prices) {
        offer.prices.electronicTotal += action.price;
      }
      // Get the electronic actions quantity
      let foundFromOffer = offer.selection.purchases.find((p: any) => p.sku === action.sku);
      if (!foundFromOffer) {
        foundFromOffer = offer.selection.sales.find((p: any) => p.sku === action.sku);
      }
      if (foundFromOffer) {
        action.quantity = foundFromOffer.quantity;
      } else {
        const foundFromExtras = offer.selection.extraServices.find((p: any) => p.sku === action.sku);
        if (foundFromExtras) {
          action.quantity = foundFromExtras.quantity;
        }
      }
    });
    offer.bankingActions.forEach((action: any) => {
      if (offer.prices) {
        offer.prices.bankingTotal += action.price;
      }
      // Get the banking actions quantity
      let foundFromOffer = offer.selection.purchases.find((p: any) => p.sku === action.sku);
      let foundExtras;
      if (!foundFromOffer) {
        foundFromOffer = offer.selection.sales.find((p: any) => p.sku === action.sku);
        if (!foundFromOffer) {
          foundExtras = offer.selection.extraServices.find((p: any) => p.sku === action.sku);
        }
      }
      if (foundFromOffer) {
        action.quantity = foundFromOffer.quantity;
      }
      if (foundExtras && foundExtras.quantity) {
        if (action.sku !== "NV-til") {
          action.quantity = foundExtras.quantity;
        } else {
          action.quantity = foundExtras.quantity * 21;
          const tilIndex = offer.selection.extraServices.findIndex((extra) => extra.sku === "NV-til");
          offer.selection.extraServices[tilIndex].quantity = foundExtras.quantity * 21;
          offer.selection.extraServices[tilIndex].showQuantity = foundExtras.quantity / 21;
        }
      }
    });

    // Make sure expirationUTC is a date
    if (!(offer.expirationUTC instanceof Date)) {
      offer.expirationUTC = new Date(offer.expirationUTC || "");
    }

    // Delete controller and group company trainings if they're not selected anymore
    (offer.selection.trainings || []).forEach((training: any, index: number, arr: any) => {
      if (training.sku === "NV-kou5") {
        const foundExtra = (offer.selection.extraServices || []).find((extra: any) => (extra.sku === "NV-kons" || extra.sku === "NV-rb") && extra.selected);
        if (!foundExtra) {
          arr.splice(index, 1);
        }
      } else if (training.sku === "NV-kou6") {
        const foundExtra = (offer.selection.extraServices || []).find((extra: any) => extra.sku === "NV-cont" && extra.selected);
        if (!foundExtra) {
          arr.splice(index, 1);
        }
      }
    });

    return offer;
  }
}
